<template lang="pug">
  validation-observer(ref="contactForm")
    form(@submit.prevent="onSubmit")
      h3 Customer Information

      .form-group
        select.form-control(v-model="fields.title")
          option(value='Mr.') Mr.
          option(value='Ms.') Ms.

      .row
        .col-sm-6
          validation-provider(
            v-slot="{ errors, valid }"
            rules="required"
            name="First Name"
          )
            .form-group
              label(for="firstname") First Name *
              input#firstname.form-control(
                v-model="fields.firstname"
                type="text"
                :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
              )
              span.invalid-feedback {{ errors[0] }}

        .col-sm-6
          .form-group
            label(for="lastname") Last Name
            input#lastname.form-control(
              v-model="fields.lastname"
              type="text"
            )


      .row
        .col-sm-6
          .form-group
            label(for="mobile") Mobile
            input#mobile.form-control(
              v-model="fields.mobile"
              type="tel"
            )

        .col-sm-6
          validation-provider(
            v-slot="{ errors, valid }"
            rules="required"
            name="Email"
          )
            .form-group
              label(for="email") Email *
              input#email.form-control(
                v-model="fields.email"
                type="email"
                :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
              )
              span.invalid-feedback {{ errors[0] }}


      h3.mt-4 Company Information

      .form-group
        label(for="companyName") Company Name
        input#companyName.form-control(
          v-model="fields.company_name"
          type="text"
        )

      validation-provider(
        v-slot="{ errors, valid }"
        rules="required"
        name="Business Type"
      )
        .form-group
          label(for="businessType") Business Type *
          select.form-control(
            v-model="fields.business_type"
            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          )
            option(value="" disabled selected) Select Business Type
            option(value="Paper Merchant") Paper Merchant
            option(value="Industry factory") Industry factory
            option(value="Converter") Converter
            option(value="End user") End user
            option(value="Brand owner") Brand owner
            option(value="Other") Other
          span.invalid-feedback {{ errors[0] }}


      .form-group.textarea
        label(for='address') Address
        textarea#address.form-control(
          v-model="fields.address"
          rows='4'
        )

      validation-provider(
        v-slot="{ errors, valid }"
        rules="required"
        name="Country"
      )
        .form-group
          label(for="country") Country *
          select.form-control(
            v-model="fields.country"
            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          )
            option(value="" disabled selected) Select a Country
            option(value="Afghanistan") Afghanistan
            option(value="Aland Islands") Aland Islands
            option(value="Albania") Albania
            option(value="Algeria") Algeria
            option(value="American Samoa") American Samoa
            option(value="Andorra") Andorra
            option(value="Angola") Angola
            option(value="Anguilla") Anguilla
            option(value="Antarctica") Antarctica
            option(value="Antigua And Barbuda") Antigua And Barbuda
            option(value="Argentina") Argentina
            option(value="Armenia") Armenia
            option(value="Aruba") Aruba
            option(value="Australia") Australia
            option(value="Austria") Austria
            option(value="Azerbaijan") Azerbaijan
            option(value="Bahamas") Bahamas
            option(value="Bahrain") Bahrain
            option(value="Bangladesh") Bangladesh
            option(value="Barbados") Barbados
            option(value="Belarus") Belarus
            option(value="Belgium") Belgium
            option(value="Belize") Belize
            option(value="Benin") Benin
            option(value="Bermuda") Bermuda
            option(value="Bhutan") Bhutan
            option(value="Bolivia") Bolivia
            option(value="Bosnia And Herzegovina") Bosnia And Herzegovina
            option(value="Botswana") Botswana
            option(value="Bouvet Island") Bouvet Island
            option(value="Brazil") Brazil
            option(value="British Indian Ocean Territory") British Indian Ocean Territory
            option(value="Brunei Darussalam") Brunei Darussalam
            option(value="Bulgaria") Bulgaria
            option(value="Burkina Faso") Burkina Faso
            option(value="Burundi") Burundi
            option(value="Cambodia") Cambodia
            option(value="Cameroon") Cameroon
            option(value="Canada") Canada
            option(value="Cape Verde") Cape Verde
            option(value="Cayman Islands") Cayman Islands
            option(value="Central African Republic") Central African Republic
            option(value="Chad") Chad
            option(value="Chile") Chile
            option(value="China") China
            option(value="Christmas Island") Christmas Island
            option(value="Cocos (Keeling) Islands") Cocos (Keeling) Islands
            option(value="Colombia") Colombia
            option(value="Comoros") Comoros
            option(value="Congo") Congo
            option(value="Congo, The Democratic Republic Of The") Congo, The Democratic Republic Of The
            option(value="Cook Islands") Cook Islands
            option(value="Costa Rica") Costa Rica
            option(value="Cote D'Ivoire") Cote D'Ivoire
            option(value="Croatia") Croatia
            option(value="Cuba") Cuba
            option(value="Cyprus") Cyprus
            option(value="Czech Republic") Czech Republic
            option(value="Denmark") Denmark
            option(value="Djibouti") Djibouti
            option(value="Dominica") Dominica
            option(value="Dominican Republic") Dominican Republic
            option(value="Ecuador") Ecuador
            option(value="Egypt") Egypt
            option(value="El Salvador") El Salvador
            option(value="Equatorial Guinea") Equatorial Guinea
            option(value="Eritrea") Eritrea
            option(value="Estonia") Estonia
            option(value="Ethiopia") Ethiopia
            option(value="Falkland Islands (Malvinas)") Falkland Islands (Malvinas)
            option(value="Faroe Islands") Faroe Islands
            option(value="Fiji") Fiji
            option(value="Finland") Finland
            option(value="France") France
            option(value="French Guiana") French Guiana
            option(value="French Polynesia") French Polynesia
            option(value="French Southern Territories") French Southern Territories
            option(value="Gabon") Gabon
            option(value="Gambia") Gambia
            option(value="Georgia") Georgia
            option(value="Germany") Germany
            option(value="Ghana") Ghana
            option(value="Gibraltar") Gibraltar
            option(value="Greece") Greece
            option(value="Greenland") Greenland
            option(value="Grenada") Grenada
            option(value="Guadeloupe") Guadeloupe
            option(value="Guam") Guam
            option(value="Guatemala") Guatemala
            option(value="Guernsey") Guernsey
            option(value="Guinea") Guinea
            option(value="Guinea-Bissau") Guinea-Bissau
            option(value="Guyana") Guyana
            option(value="Haiti") Haiti
            option(value="Heard Island And Mcdonald Islands") Heard Island And Mcdonald Islands
            option(value="Holy See (Vatican City State)") Holy See (Vatican City State)
            option(value="Honduras") Honduras
            option(value="Hong Kong") Hong Kong
            option(value="Hungary") Hungary
            option(value="Iceland") Iceland
            option(value="India") India
            option(value="Indonesia") Indonesia
            option(value="Iran, Islamic Republic Of") Iran, Islamic Republic Of
            option(value="Iraq") Iraq
            option(value="Ireland") Ireland
            option(value="Isle Of Man") Isle Of Man
            option(value="Israel") Israel
            option(value="Italy") Italy
            option(value="Jamaica") Jamaica
            option(value="Japan") Japan
            option(value="Jersey") Jersey
            option(value="Jordan") Jordan
            option(value="Kazakhstan") Kazakhstan
            option(value="Kenya") Kenya
            option(value="Kiribati") Kiribati
            option(value="Korea, Democratic People'S Republic Of") Korea, Democratic People'S Republic Of
            option(value="Korea, Republic Of") Korea, Republic Of
            option(value="Kuwait") Kuwait
            option(value="Kyrgyzstan") Kyrgyzstan
            option(value="Lao People'S Democratic Republic") Lao People'S Democratic Republic
            option(value="Latvia") Latvia
            option(value="Lebanon") Lebanon
            option(value="Lesotho") Lesotho
            option(value="Liberia") Liberia
            option(value="Libyan Arab Jamahiriya") Libyan Arab Jamahiriya
            option(value="Liechtenstein") Liechtenstein
            option(value="Lithuania") Lithuania
            option(value="Luxembourg") Luxembourg
            option(value="Macao") Macao
            option(value="Macedonia, The Former Yugoslav Republic Of") Macedonia, The Former Yugoslav Republic Of
            option(value="Madagascar") Madagascar
            option(value="Malawi") Malawi
            option(value="Malaysia") Malaysia
            option(value="Maldives") Maldives
            option(value="Mali") Mali
            option(value="Malta") Malta
            option(value="Marshall Islands") Marshall Islands
            option(value="Martinique") Martinique
            option(value="Mauritania") Mauritania
            option(value="Mauritius") Mauritius
            option(value="Mayotte") Mayotte
            option(value="Mexico") Mexico
            option(value="Micronesia, Federated States Of") Micronesia, Federated States Of
            option(value="Moldova, Republic Of") Moldova, Republic Of
            option(value="Monaco") Monaco
            option(value="Mongolia") Mongolia
            option(value="Montserrat") Montserrat
            option(value="Morocco") Morocco
            option(value="Mozambique") Mozambique
            option(value="Myanmar") Myanmar
            option(value="Namibia") Namibia
            option(value="Nauru") Nauru
            option(value="Nepal") Nepal
            option(value="Netherlands") Netherlands
            option(value="Netherlands Antilles") Netherlands Antilles
            option(value="New Caledonia") New Caledonia
            option(value="New Zealand") New Zealand
            option(value="Nicaragua") Nicaragua
            option(value="Niger") Niger
            option(value="Nigeria") Nigeria
            option(value="Niue") Niue
            option(value="Norfolk Island") Norfolk Island
            option(value="Northern Mariana Islands") Northern Mariana Islands
            option(value="Norway") Norway
            option(value="Oman") Oman
            option(value="Pakistan") Pakistan
            option(value="Palau") Palau
            option(value="Palestinian Territory, Occupied") Palestinian Territory, Occupied
            option(value="Panama") Panama
            option(value="Papua New Guinea") Papua New Guinea
            option(value="Paraguay") Paraguay
            option(value="Peru") Peru
            option(value="Philippines") Philippines
            option(value="Pitcairn") Pitcairn
            option(value="Poland") Poland
            option(value="Portugal") Portugal
            option(value="Puerto Rico") Puerto Rico
            option(value="Qatar") Qatar
            option(value="Reunion") Reunion
            option(value="Romania") Romania
            option(value="Russian Federation") Russian Federation
            option(value="Rwanda") Rwanda
            option(value="Saint Helena") Saint Helena
            option(value="Saint Kitts And Nevis") Saint Kitts And Nevis
            option(value="Saint Lucia") Saint Lucia
            option(value="Saint Pierre And Miquelon") Saint Pierre And Miquelon
            option(value="Saint Vincent And The Grenadines") Saint Vincent And The Grenadines
            option(value="Samoa") Samoa
            option(value="San Marino") San Marino
            option(value="Sao Tome And Principe") Sao Tome And Principe
            option(value="Saudi Arabia") Saudi Arabia
            option(value="Senegal") Senegal
            option(value="Serbia And Montenegro") Serbia And Montenegro
            option(value="Seychelles") Seychelles
            option(value="Sierra Leone") Sierra Leone
            option(value="Singapore") Singapore
            option(value="Slovakia") Slovakia
            option(value="Slovenia") Slovenia
            option(value="Solomon Islands") Solomon Islands
            option(value="Somalia") Somalia
            option(value="South Africa") South Africa
            option(value="South Georgia And The South Sandwich Islands") South Georgia And The South Sandwich Islands
            option(value="Spain") Spain
            option(value="Sri Lanka") Sri Lanka
            option(value="Sudan") Sudan
            option(value="Suriname") Suriname
            option(value="Svalbard And Jan Mayen") Svalbard And Jan Mayen
            option(value="Swaziland") Swaziland
            option(value="Sweden") Sweden
            option(value="Switzerland") Switzerland
            option(value="Syrian Arab Republic") Syrian Arab Republic
            option(value="Taiwan, Province Of China") Taiwan, Province Of China
            option(value="Tajikistan") Tajikistan
            option(value="Tanzania, United Republic Of") Tanzania, United Republic Of
            option(value="Thailand" selected="selected") Thailand
            option(value="Timor-Leste") Timor-Leste
            option(value="Togo") Togo
            option(value="Tokelau") Tokelau
            option(value="Tonga") Tonga
            option(value="Trinidad And Tobago") Trinidad And Tobago
            option(value="Tunisia") Tunisia
            option(value="Turkey") Turkey
            option(value="Turkmenistan") Turkmenistan
            option(value="Turks And Caicos Islands") Turks And Caicos Islands
            option(value="Tuvalu") Tuvalu
            option(value="Uganda") Uganda
            option(value="Ukraine") Ukraine
            option(value="United Arab Emirates") United Arab Emirates
            option(value="United Kingdom") United Kingdom
            option(value="United States") United States
            option(value="United States Minor Outlying Islands") United States Minor Outlying Islands
            option(value="Uruguay") Uruguay
            option(value="Uzbekistan") Uzbekistan
            option(value="Vanuatu") Vanuatu
            option(value="Venezuela") Venezuela
            option(value="Viet Nam") Viet Nam
            option(value="Virgin Islands, British") Virgin Islands, British
            option(value="Virgin Islands, U.S.") Virgin Islands, U.S.
            option(value="Wallis And Futuna") Wallis And Futuna
            option(value="Western Sahara") Western Sahara
            option(value="Yemen") Yemen
            option(value="Zambia") Zambia
            option(value="Zimbabwe") Zimbabwe
          span.invalid-feedback {{ errors[0] }}

      .row
        .col-md-6
          .form-group
            label(for="companyMobile") Mobile
            input#companyMobile.form-control(
              v-model="fields.company_mobile"
              type="tel"
            )
        .col-md-6
          .form-group
            label(for="companyTelephone") Telephone
            input#companyTelephone.form-control(
              v-model="fields.company_telephone"
              type="tel"
            )

      h3.mt-4 Subject Information

      validation-provider(
        v-slot="{ errors, valid }"
        rules="required"
        name="Subject"
      )
        .form-group
          label Subject *
          select.form-control(
            v-model="fields.subject"
            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          )
            option(value='' disabled='' selected='') Select Subject
            option(value='Inquiry for MG Paper.') Inquiry for MG Paper.
            option(value='Inquiry for MWL (MG Paper + PE)') Inquiry for MWL (MG Paper + PE)
            option(value='Interested to be our agent.') Interested to be our agent.
            option(value='Inquiry for A4 paper from group company.') Inquiry for A4 paper from group company.
            option(value='Want to be supplier.') Want to be supplier.
            option(value='Other') Other
          span.invalid-feedback {{ errors[0] }}


      validation-provider(
        v-slot="{ errors, valid }"
        rules="required"
        name="Requirement"
      )
        .form-group.textarea
          label(for='requirement') Requirement *
          textarea#requirement.form-control(
            v-model="fields.requirement"
            rows='4'
            :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          )
          span.invalid-feedback {{ errors[0] }}


      validation-provider(
        v-slot="{ errors, valid }"
        rules="required"
        name="Accept"
      )
        .custom-control.custom-checkbox.mb-5
          input#privacy.custom-control-input(
            type="checkbox"
            v-model="fields.privacy"
            :class="{ 'is-invalid': errors[0] }"
          )
          label.custom-control-label(for="privacy") Yes, I have read and accept the 
            a(:href="`https://www.scgpackaging.com/${lang}/privacy-notice`" target="_blank")  Privacy Policy
          span.invalid-feedback {{ errors[0] }}

      p.text-right
        button.btn.btn-primary.pl-4.pr-4(
          type="submit"
          :disabled="buttonLoading || !fields.privacy"
        )
          span.spinner-border.spinner-border-sm(
            v-if="buttonLoading"
            role="status"
            aria-hidden="true"
          )
          //- span Loading..
          |  Submit


</template>

<script>
import MoveTo from 'moveTo'
import { Confirm } from 'notiflix'
import axios from 'axios'

export default {
  data: () => ({
    buttonLoading: false,
    fields: {},
    lang: SNP.lang,
  }),

  created() {
    this.resetForm()
  },

  methods: {
    resetForm() {
      this.fields = {
        business_type: '',
        title: 'Mr.',
        country: '',
        subject: '',
      }
    },

    onSubmit() {
      this.buttonLoading = true
      const form = this.$refs.contactForm
      form.validate().then(success => {
        if (!success) {
          setTimeout(() => {
            const errors = Object.entries(form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length);
              
            const to = form.refs[errors[0]['key']].$el
            const moveTo = new MoveTo({
              tolerance: 90,
              duration: 800,
            })

            moveTo.move(to)
            this.buttonLoading = false
          }, 100)
          return;
        } else {
          Confirm.Init({
            width: '350px',
            fontFamily: 'Prompt',
            borderRadius: '5px',
            titleColor: '#d82c2c',
            okButtonBackground: '#d82c2c',
            messageMaxLength: 10000,
            plainText: false,
          })

          const message = `${SNP.icon.checkmark} We have received your message and would like to thank you for writing to us. <br> We will contact you shortly.`

          axios
            .post(`${SNP.api_endpoint}v1/contact`, this.fields)
            .then(({ status }) => {
              Confirm.Show('Thanks for being awesome!', message, 'Ok')
              requestAnimationFrame(() => {
                this.resetForm()
                form.reset()
              })
            })
            .catch(error => {
              console.log(error)
            })
            .then(() =>{
              this.buttonLoading = false
            })
        }
      });
      // try {
      // } catch (error) {
      //   const errors = error.response.data.errors
      //   form.setErrors(errors)
      // } finally {
      // }
    },
  },
}
</script>

